import { Menu, MenuItemProps, Portal } from '@chakra-ui/react';
import { MoreHorizIcon } from 'assets/icons/v2';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { ReactElement } from 'react';

export const WorksheetMenu = ({
  items,
}: {
  items: {
    icon: ReactElement;
    label: string;
    onClick: MenuItemProps['onClick'];
    dangerousAction?: boolean;
  }[];
}): ReactElement => {
  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <NovaIconButton
          aria-label="Optionen"
          variant="primary"
          size="s"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={MoreHorizIcon}
        />
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            backgroundColor="background.primary"
            borderColor="border.accent"
            borderWidth="1px"
            borderRadius="m"
            boxShadow="md"
          >
            {items.map((item) => (
              <Menu.Item
                value={item.label}
                onClick={item.onClick}
                color={item.dangerousAction ? 'text.error' : 'inherit'}
                _hover={{ backgroundColor: 'background.canvas' }}
                cursor="pointer"
              >
                {item.icon}
                {item.label}
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
